/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import e from"../../../core/has.js";const o=e("esri-mobile")?64:128,r=o/128,t=Math.ceil(Math.sqrt(o)),s=(o+2)*t,i=1e5,a=128,c=s/1560;export{s as ATLAS_SIZE,r as TEXTURE_SCALE,t as TILE_ROWS,o as TILE_SIZE,c as WEATHER_MAP_SCALE,i as WEATHER_MAP_SIZE,a as WEATHER_TILE_SIZE};
